<template>
    <div :class="['ui-dropdown', open ? 'open' : 'closed']">
        <slot>
            <button class="ui-dropdown__button" @click="open = !open">
                <span></span>
                <span></span>
                <span></span>
            </button>
        </slot>
        <div :class="['ui-dropdown__menu']" v-if="open">
            <ui-tab-list :tabs="list" :callback="onClick" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ui-dropdown',
        props: ['list'],
        data() {
            return {
                open: false,
            };
        },
        methods: {
            onClick() {
                this.open = false;
            },
        },
    };
</script>

<style>
    .ui-dropdown {
        display: inline-block;
        position: relative;
    }

    .ui-dropdown__menu {
        position: absolute;
        right: 0;
        background: #FFF;
        border: 1px solid rgba(0, 0, 0, .2);
        border-radius: 5px;
        min-width: 150px;
        z-index: 100;
        margin-top: 6px;
    }

    .ui-dropdown__button {
        display: flex;
        border-radius: 4px;
        height: 18px;
        align-items: center;
        opacity: .5;
        line-height: 100%;
        padding: 2px 5px;
        border: 1px solid transparent;
    }

    .ui-dropdown__button:hover, .ui-dropdown.open .ui-dropdown__button {
        opacity: .7;
        border: 1px solid rgba(0, 0, 0, .4);
    }

    .ui-dropdown__button span {
        width: 4px;
        height: 4px;
        margin: 1px;
        background-color: #000;
        border-radius: 999px;
    }

    .ui-dropdown__button span:last-child {
        margin-right: 0;
    }
    .ui-dropdown__button span:first-child {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// UiDropdown.vue?c72aafac